// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx","828":"component---src-pages-post-markdown-remark-frontmatter-slug-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"b74175627e2a6374cdbd","691":"28e548cd7af50a6cbc3b","828":"d4e806c51157e89c4d01","883":"91f95cda45a110c78be2"}[chunkId] + ".js";
};